import React from 'react';
import LineAtCoordinates from '../../LineAtCoordinates/LineAtCoordinates';
import PropTypes from 'prop-types';

export default function LinkedTextElementChains ({ chains }) {
  return chains.map(({ lineToNext: { key, ...lineToNext } }) => (
      <LineAtCoordinates key={key} {...lineToNext} />
  ));
}

LinkedTextElementChains.propTypes = {
  chains: PropTypes.array
};
